import { create } from 'zustand';

const useLayoutStore = create((set) => ({
  isToggle: false, // Initial state
  workMode: false,
  setIsWorkMode: (value) => set({ workMode: value }), // Setter function
  setIsToggle: (value) => set({ isToggle: value }), // Setter function
}));

export default useLayoutStore;
